import { dyslexiaInstruction } from "@constants/instructionConstants";
import { virtualAssistanceDyslexiaAloudReadingConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
  TextOrientation,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  CALIBRATION_TOGGLE_OPTION_NEW_APK,
} from "../configurationHelperConstants";
import { DYSLEXIA_SUPPORTED_LANGUAGES } from "@constants/languageConstants";

export const availableDyslexiaTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.Dyslexia],
    choices: [
      {
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.ReadingAssessment],
        value: TestType.ReadingAssessment,
      },
    ],
    isMandatory: true,
    configurationFieldName: "testType",
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
    toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION_NEW_APK },
  },
  languageOptions: {
    choices: DYSLEXIA_SUPPORTED_LANGUAGES,
    validSinceVersion: null,
    configurationFieldName: "testLanguage",
  },
  virtualAssistantOptions: AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  testSpeedOptions: null,
};

export const dyslexiaTestConfiguration: TestConfiguration = {
  name: TestCategory.Dyslexia,
  testType: TestType.ReadingAssessment,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: DYSLEXIA_SUPPORTED_LANGUAGES[1].value,
  virtualAssistanceConfig: virtualAssistanceDyslexiaAloudReadingConfig,
  isPressToStartEnabled: true,
  extraData: { textOrientation: TextOrientation.L2R },
};

export const dyslexiaUIConfiguration: TestUIConfiguration = {
  showProgressBar: false,
  instructions: dyslexiaInstruction,
};
